import React from 'react';
import { NavLink } from 'react-router-dom';

export function CTASection() {
  return (
    <section className='cta-section'>
      <div className="container">
        <div className="cta-content shadow-lg">

          <h2 className="cta-title">
            READY TO <span>LEVEL UP</span> YOUR DOCUMENT MANAGEMENT?
          </h2>
          <p className="cta-description">
            Join thousands of businesses that have simplified their document workflows with DocuSafe.ai. Get started today with a free trial.
          </p>
          <div className="cta-buttons">
            <NavLink to="/pricing" className={"text-decoration-none me-2"}>
              <button className="btn-start">
                Start Free Trial
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.16666 10H15.8333M15.8333 10L10 4.16667M15.8333 10L10 15.8333"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </NavLink>
            {/* <button className="btn btn-contact">Contact Sales</button> */}
            <button className="btn ">
              <NavLink to="/contact" className={"btn-contact-link"}>
                Contact Sales
              </NavLink>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
} 